import { Col, Row } from 'antd'
import { Fragment } from 'react'
import Slider from 'react-slick'

export const Testimonials = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 10000,
    fade: true,
  }

  return (
    <Fragment>
      <div className='container page'>
        <h1 className='text-center'>Fellowship Testimonials</h1>
        <div className='section-inner'>
          <Slider {...settings}>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/raj.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/raj.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Ru Raj 2024-2025</h4>
                  <h5>University of Alberta, Edmonton, Canada</h5>
                  <br />
                  <p>
                    My time as a combined spinal surgical fellow at the Calgary Spine
                    Program in Alberta has been one of the most formative experiences of
                    my career thus far. From the outset, I felt genuinely welcomed into a
                    program that maintains high clinical standards while fostering a
                    supportive and collegial environment.
                  </p>
                  <p>
                    One of the most impactful aspects of my experience was how early I was
                    trusted and challenged in an operative setting. The breadth and
                    complexity of cases are exceptional, and each day provided
                    opportunities to expand both my technical abilities but more
                    importantly, my clinical judgment of “when to cut”. Furthermore, the
                    majority of my residency spinal surgical training revolved around
                    traditional open posterior techniques; the variety of MIS including
                    endoscopic techniques, and anterior and lateralsurgical techniques
                    that bolsters this program was a huge draw when selecting a
                    fellowship. Over a relatively short period of time, I noticed a
                    significant growth in my confidence surgically, which is something I
                    attribute directly to the strength and intentionality of the
                    mentorship within the program.
                  </p>
                  <p>
                    When it comes to the faculty, I would consider them outstanding
                    educators and mentors. They are deeply invested in the development of
                    their fellows and consistently create an environment that encourages
                    thoughtful decision-making and progressive independence. I was
                    actively involved in all aspects of patient care, from preoperative
                    planning to intraoperative management and postoperative follow-up. The
                    balance between autonomy and guidance was particularly valuable, and
                    it has left me feeling well prepared as I transitioned into
                    independent practice, and has equipped me to become a leader to my
                    trainees in a positive way.
                  </p>
                  <p>
                    Beyond the clinical experience, the program’s culture is one of its
                    strengths. There is a strong sense of teamwork and mutual respect
                    among fellows, staff and more importantly between the orthopaedic and
                    neurosurgical group. This collaborative atmosphere allows us as
                    fellows to learn a variety of techniques that may not be familiar
                    given our residency training. As an orthopaedic surgeon by trade, I do
                    find that I currently use a lot of skills not only from my orthopaedic
                    mentors, but from our neurosurgical colleagues as well, which has been
                    vital as I begin independent practice.The academic structure of the
                    program further complements the clinical training, with regular
                    teaching sessions and opportunities to participate in meaningful
                    research. The emphasis on evidence-based practice has strengthened my
                    approach to patient care and decision-making and has helped shaped
                    what I seek to achieve as an academic surgeon.
                  </p>
                  <p>
                    Overall, this fellowship has been a truly transformative experience
                    for me and has provided me with advanced surgical skills, strengthened
                    my clinical judgment, and has instilled in me the confidence to begin
                    independent practice. I would strongly recommend the Calgary Spine
                    Program to anyone seeking comprehensive, diverse, cutting-edge, and
                    high-quality training within the field.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source
                      srcSet={'/images/team/pelletier-roy.webp'}
                      type='image/webp'
                    />
                    <img
                      srcSet={'/images/team/pelletier-roy.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Remi Pelletier-Roy 2023-2024</h4>
                  <h5>Université de Montréal, Montréal, Canada</h5>
                  <br />
                  <p>
                    The Calgary Spine Fellowship was a pivotal chapter in my professional
                    development. Right from the start, it was clear that this program
                    prioritized fellow training and education. It is designed to cultivate
                    not just technical excellence, but also the confidence and judgment
                    essential to becoming a truly independent spine surgeon. The case mix
                    was comprehensive, with close to 400 surgical cases in just twelve
                    months, incorporating open, minimally invasive, anterior, posterior,
                    and lateral approaches. Call was a challenging variety of trauma,
                    metastatic tumors and infection cases. This provided invaluable
                    experience in managing acute spine pathology and navigating complex
                    decision-making. It gave me a realistic and well-rounded understanding
                    of what it takes to handle call at a high-volume academic center.
                  </p>
                  <p>
                    What stood out most was the balance between supervision and autonomy.
                    The faculty trusted us to grow, providing just the right amount of
                    guidance while encouraging leadership in the OR. This approach
                    challenged me to refine my decision-making and surgical efficiency,
                    while accelerating my growth by clearly highlighting areas where I
                    needed to improve. The academic component of the program was equally
                    robust, featuring resident teaching sessions, fellow discussion
                    rounds, complex deformity case reviews, journal clubs, and strong
                    support for research.
                  </p>
                  <p>
                    This program not only prepared me clinically - it played a defining
                    role in shaping me as a spine surgeon and as a collaborative team
                    member in the operating room. I’m proud and grateful to have had the
                    opportunity to be part of the Calgary Spine Program, and I will carry
                    the lessons learned from this fellowship with me throughout my career.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/almojuela.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/almojuela.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Alysa Almojuela 2022-2023</h4>
                  <h5>University of Manitoba, Canada</h5>
                  <br />
                  <p>
                    The Calgary Spine Fellowship produces well-rounded, proficient spine
                    surgeons year after year, and I am truly grateful for my own
                    experience with this incredible program. The clinical experience
                    covered everything from occiput to sacrum, and a wide range of
                    approaches including MIS, open, posterior, anterior and lateral. In
                    the operating room, through appropriate supervision and gradual
                    independence, the team helped bolster my growing autonomy and
                    leadership skills as the months went by. I felt ready to tackle a busy
                    academic practice at the end of fellowship, thanks to the broad
                    clinical exposure and operative experiences I had.
                  </p>
                  <p>
                    One of the best aspects of the program was the educational curriculum,
                    which included resident rounds, fellow rounds, morbidity and mortality
                    rounds and journal clubs. Gaining valuable insight from multiple
                    surgeons with varying practices and a range of personalities taught me
                    that multiple solutions can exist for the same problem, and sometimes
                    there is no one correct answer. The brutal honesty of the surgeons,
                    pearls of wisdom, and friendly debates greatly enriched the overall
                    learning experience.
                  </p>
                  <p>
                    Importantly, the Calgary surgeons were also great role models in
                    collegiality, and I am thankful for the career-long connections this
                    experience created. My evolution from resident, to fellow, to
                    neurosurgeon and spine attending, was fostered by mentors in Calgary,
                    who were always quick to share their tips and tricks and lessons
                    learned. The fantastic reputation of the Calgary Spine Program is
                    clearly well-earned, and I am grateful to have had the opportunity to
                    train as a Calgary fellow.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/cowley.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/cowley.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Richard Cowley 2021-2022</h4>
                  <h5>New Zealand</h5>
                  <br />
                  <p>
                    My name is Richard Joseph Cowley, I’m not Australian and I’m a proud
                    Calgary Spine Fellow. The Calgary Spine Fellowship was the axis for a
                    brilliant time for my family and I. What brought us there was a desire
                    to work for and within a fantastic spine program. What we took away
                    was so much more.
                  </p>
                  <blockquote>
                    “It’s the decision, not the incision that will be the most difficult
                    and the most important.”
                  </blockquote>
                  <p>
                    Having now practiced for 6 months in New Zealand, there are many
                    Canadian accents which I hear on a daily frequency. These mentor
                    voices have an array of Alberrrrrta twang, cowboy volume, passionate
                    tone, enthused speed and passive aggression. They all speak with truth
                    and come from experience. The decisions are now mine but I’m grateful
                    for the voices guiding me towards sound clinical decision making and
                    better choices in life.
                  </p>
                  <blockquote>
                    “If you get a referral from a colleague, it’s unlikely to be low lying
                    fruit.”
                  </blockquote>
                  <p>
                    The Spine Surgeons of Calgary treat their fellows as colleagues. I
                    felt empowered to lead, prepare and develop independence through
                    appropriate autonomy and supervision. Working closely with an array of
                    personalities and approaches I was able to save many quotes in a file
                    labeled ‘Spine Wisdom’. I was reminded of the above quote on my first
                    referral in New Zealand being a Charcot spine! The high volume of
                    ‘work’ (I loved it all) within an incredibly supportive and
                    encouraging environment has provided a base of clinical experience to
                    begin my career. Outside of this ‘work’ the well lubricated Journal
                    Clubs, openly honest fellow rounds, shark tank resident rounds and
                    supportive research environment shakes the pillars of your
                    understanding until you eventually realize that consensus is a
                    delusion and you have to make a decision and get on with it! The
                    fellowship continues to attract quality applicants, a testament to the
                    vision and hard work of the leadership.
                  </p>
                  <blockquote>
                    <b>He aha te mea nui o te ao</b>
                    <br />
                    What is the most important thing in the world?
                    <br />
                    <b>He tangata, he tangata, he tangata</b>
                    <br />
                    It is the people, it is the people, it is the people
                  </blockquote>
                  <p>
                    As a family we were warmly welcome by the Spine Community and the
                    people of Calgary. Our children became so comfortable with their local
                    group of friends they would run naked from house to house on 35th St
                    NW! We created friendships with the families of my co-fellows and
                    enjoyed everything the fellowship has to offer together. We look
                    forward to nurturing all of these bonds on many returns to Western
                    editions of Canadian Spine Society and would love to repay the
                    hospitality if anyone was to venture to the South Pacific.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/singh.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/singh.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Vishwajeet Singh, 2020-2021</h4>
                  <h5>Bankura Sammilani Medical College, Bankura, West Bengal, India</h5>
                  <br />
                  <p>
                    I was so excited to hear about my acceptance for the combined spine
                    fellowship at the University of Calgary. I saw it as a great
                    opportunity to work on my weaknesses and consolidate on the skills I
                    had. I flew in from another side of the globe expecting a bumpy start
                    but the support I received from residents, co-fellows and the staff
                    was unbelievable. I started my first day in the OR assisting on direct
                    lateral interbody fusion and a few months down the road, I was doing
                    it.
                  </p>
                  <p>
                    The impact of this training was comprehensive; I acquired excellent
                    operative skills and clinical judgement but what I enjoyed most was
                    the engagement in research meetings, support from the preceptors in
                    taking the research forward and thorough deliberations during fellow’s
                    rounds.
                  </p>
                  <p>
                    The program provided excellent autonomy in the development and
                    execution of the treatment plan that has helped me tremendously in
                    becoming an independent practitioner. I got the opportunity to work
                    closely with both orthopedic and neurosurgery residents and I enjoyed
                    bringing interesting cases for them on the weekly spine rounds.
                  </p>
                  <p>
                    Calgary has a unique side - its proximity to the mountains. I explored
                    the mountains during summer hikes and learned cross country and
                    downhill skiing in winter, for the first time. It is amazing to
                    reflect on so much happening in just one year and when I look back, I
                    could not have asked for anything better. I developed lifelong
                    relationships with my colleagues and mentors, and I will forever
                    remain indebted to their love and support.
                  </p>
                  <p>
                    I will be proud to flaunt I trained with the Calgary Spine Program.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/kassam.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/kassam.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Faizal Kassam, 2019-2020</h4>
                  <h5>Queen's University, Canada</h5>
                  <br />
                  <p>
                    When I showed up to Calgary in July 2020, I was decent with a mallet
                    but barely knew how to hold a Kerrison. I looked down, looked up
                    again, and suddenly it was March 2021. I was doing anterior cervical
                    discectomies with a resident assisting.
                  </p>
                  <p>
                    From the entertainment of Spine Rounds to the delicious offerings at
                    monthly journal clubs, the year flew by. Through the hard work and
                    patience of my mentors in Calgary, I became technically proficient in
                    anterior, lateral and posterior-based procedures. I will always be
                    thankful to my co-Fellows, the Residents that I worked with, and the
                    Attendings who provided me with unlimited opportunities to grow. I
                    think of them every single day.
                  </p>
                  <p>
                    For anyone lucky enough to be admitted to this fellowship, my advice
                    would be to take it before the opportunity is gone. You won’t regret
                    it. I am currently an attending spine & trauma surgeon at Queen’s
                    University and will always be proud to say that I’m a Calgary-trained
                    spine surgeon.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/aoude.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/aoude.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Ahmed Aoude, 2018-2019</h4>
                  <h5>McGill University, Canada</h5>
                  <br />
                  <p>
                    I remember receiving my acceptance to complete a Fellowship in Spine
                    at University of Calgary very vividly. I was at he same time
                    considering Harvard, Mayo Clinic & John Hopkins. I was very excited,
                    but i have to admit, not too sure about the city and program. I then
                    decided to find out more and talk to previous Fellows. Their unanimous
                    high appraisal of the program was enough to convince me to join this
                    wonderful team. I am very grateful to have made the right decision
                    every day.
                  </p>
                  <p>
                    After this fellowship I feel confident to attack any spine cases
                    whether small or big. This I owe to all my mentors. I now am
                    confortable to do MIS cases, lateral approaches, anterior approaches,
                    tumor, trauma, degenerative spine, cervical cases and deformity. The
                    team at University of Calgary were all great teachers but also great
                    role models for all Fellows when it came to patient care. I also
                    greatly appreciate the respect and kindness of all operating room
                    staff during my time there.
                  </p>
                  <p>
                    All these factors make the Spine Fellowship at University of Calgary
                    so highly regarded. I am currently completing a fellowship in
                    orthopaedic oncology in Toronto and find myself doing complex cases
                    daily but feel competent after all the surgucal experience and complex
                    cases I completed in Calgary.
                  </p>
                  <p>
                    I want to thank all my fellowship supervisors for the exceptional
                    mentorship, teaching and most importantly, friendships I have built.
                    The reputation of the University of Calgary Spine Program as being the
                    best program in North America is true and warranted.
                  </p>
                  <p>
                    PS... It's not even been a year and I miss Calgary... I miss the
                    beauty and peacefulness of the city but also my mentors and colleagues
                    inside and outside the operating room.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/fox.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/fox.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Shandy Fox, 2016-2017</h4>
                  <h5>University of Saskatchewan, Canada</h5>
                  <br />
                  <p>
                    The Calgary Adult Combined Spine Surgery Fellowship offers an amazing
                    educational experience that will prepare you for a successful career
                    in spinal surgery. First and foremost, the program is truly an example
                    of what an integrated program should be. Both specialties are equally
                    represented and the staff work very well together, emulating a
                    positive and team-oriented environment. Secondly, it is a unique
                    experience to work with so many skilled surgeons. As each of them have
                    varying interests and approaches, the learner gains a range of skills
                    and knowledge to add to their “toolbox”. The case volume is
                    substantial with exposure to a wide variety of pathologies, from
                    simple to complex. The program also embraces evidence-based medicine,
                    new technology and new techniques that further advance the learning
                    experience. I was very fortunate to learn from and work alongside such
                    a great group and I highly recommend this fellowship!
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/stratton.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/stratton.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Alexandra Stratton, 2015-2016</h4>
                  <h5>Memorial University of Newfoundland, Canada</h5>
                  <br />
                  <p>
                    The Calgary Combined Spinal Surgery Fellowship provides a phenomenal
                    training experience. Pros include: the 6 month/6 month split between
                    ortho and neurosurgery giving adequate exposure to both, exceptional
                    technical skill of the surgeons and their interest in teaching,
                    variety of procedures the fellow is exposed to (from routine lumbar
                    decompressions and ACDFs to complex deformity corrections and tumour
                    cases) and approaches (MIS/percutaneous, open, with/without
                    navigation, etc.), graduated responsibility depending on fellow’s
                    level of experience, high volume of cases and structured teaching
                    program. Administrative duties/scut work is kept to a minimum and the
                    ratio between OR, clinic and research is ideal. There is ample
                    opportunity for early involvement in research projects with the goal
                    of presenting at CSS in February. This fellowship prepares the fellow
                    well for a career in complex spinal surgery in an academic centre.
                  </p>
                </Col>
              </Row>
            </div>
            <div>
              <Row gutter={48}>
                <Col>
                  <picture>
                    <source srcSet={'/images/team/oh.webp'} type='image/webp' />
                    <img
                      srcSet={'/images/team/oh.jpg'}
                      alt='portrait'
                      className='testimonial-img'
                    />
                  </picture>
                </Col>
                <Col xl={14}>
                  <h4>Dr. Jacob Oh, 2013-2014</h4>
                  <h5>National University of Singapore, Singapore</h5>
                  <br />
                  <p>
                    Greetings from Singapore! I am an Orthopedic Spine Consultant and I
                    had the privilege to undertake my Combined Spine Surgery Fellowship at
                    the University of Calgary in 2013/14. I had a fantastic time working
                    with 11 of the most dedicated, skillful and approachable group of
                    spine surgeons. With only 4 spine fellows, we had a substantial amount
                    of surgical time and volume, which is what most candidates desire in
                    their fellowship training. With Foothills Medical Centre having such a
                    big spine department, I had the opportunity to see, and perform, a
                    large variety of cases – from adult deformity, minimally invasive
                    surgery, complex cervical spine, tumor, acute trauma, the list goes
                    on. Also, what’s unique about this Combined Spine Surgery Fellowship
                    program is that we get to rotate through both the Neurosurgical and
                    Orthopedics teams, giving us a different perspective, which I
                    personally feel is invaluable. I would definitely recommend this
                    fellowship to anybody who is keen in spine surgery!
                  </p>
                </Col>
              </Row>
            </div>
          </Slider>
        </div>
      </div>
    </Fragment>
  )
}
